import React from 'react';
import type { FormatterProps, PatientPMMEvent } from './type';
import { convertDateInstanceToDateString } from '../../../../helpers';

const LastPharmacyNoteDateFormatter = ({ row }: FormatterProps) => {
  if (!row || row.pmmEvents.length === 0) {
    return <span>-</span>;
  }
  const data: PatientPMMEvent[] = row.pmmEvents.filter((event: any) =>
    event.name.includes('PMM'),
  );
  if (data.length === 0) {
    return <span>-</span>;
  }
  const value = data.sort((a, b) => {
    return new Date(b.event_date).getTime() - new Date(a.event_date).getTime();
  })[0].event_date;

  return <span>{convertDateInstanceToDateString(value)}</span>;
};

export default LastPharmacyNoteDateFormatter;
